import React, { useState, useMemo,useContext } from "react";
import { Redirect, useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteBudget } from "services/ConfigServices";
import { budgetpagetext } from "variables/budget";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import useBudgetTable from "./useBudgetTable.js";
import {
  Navigate,
} from "react-router-dom";

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const useStyles = makeStyles(styles);

const RTBudget = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const budgetadmin = permis.includes("budget_admin");
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;
  const { gridState, refetch, setSelectedBudgets } = useBudgetTable();
  const [redirState, setRedirState] = useState(false);
  const [budgetId, setBudgetId] = useState("");
  const [budgetName, setBudgetName] = useState("");
  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/budget/selectedbudget/",
        state: { budgetId, budgetName },
      }}
      state= {{ budgetId :budgetId,budgetName : budgetName }}
    />
  );

  let dataBudgets = gridState.data;

  const classes = useStyles();

  const columns = [
    {
      name: budgetpagetext.general.code,
      selector: (row) => row.parameters.code,
      sortable: true,
      maxWidth: "9rem",
    },
    {
      name: budgetpagetext.general.name,
      selector: (row) => row.parameters.name,
      sortable: true,
     // minWidth: "13rem",
    },
    {
      name: budgetpagetext.general.datebegin,
      sortable: true,
      selector: (row) => row.parameters.datebegin,
      //maxWidth: "10rem",
      cell: (row) =>
        row.parameters.datebegin && moment(row.parameters.datebegin).isValid()
          ? moment(row.parameters.datebegin).format("DD/MM/YYYY")
          : "",
    },
    {
      name: budgetpagetext.general.dateend,
      sortable: true,
      selector: (row) => row.parameters.dateend,
      //maxWidth: "10rem",
      cell: (row) =>
        row.parameters.dateend && moment(row.parameters.dateend).isValid()
          ? moment(row.parameters.dateend).format("DD/MM/YYYY")
          : "",
    },
    {
      name: budgetpagetext.general.amount,
      selector: (row) => row.amount,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.parameters.amount ? new Intl.NumberFormat('fr-FR',{minimumFractionDigits: 0,maximumFractionDigits:2}).format(row.parameters.amount) : '',
    },
    {
      name: budgetpagetext.general.account,
      selector: (row) => row.idgroup,
      sortable: true,
      cell: (row) => (
        <GroupCell>
          <div>{groupInfoListById["" + row.idgroup]}</div>
        </GroupCell>
      ),
    },
    {
      name: budgetpagetext.general.perimeter,
      selector: (row) => row.parameters.perimeter,
      sortable: true,
     // minWidth: "13rem",
    },
    {
      name: "",
      sortable: false,
      width: "7rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Voir les détails du budget">
              <Button
                onClick={BudgetDetail(row)}
                color={"info"}
                className={classes.actionButton}
              >
                <VisibilityIcon fontSize="large" />
              </Button>
            </Tooltip>
            {budgetadmin && (
              <CustomDeleteButton
                deleteTitle={"Suppression du budget"}
                deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le budget ${row.parameters.name} ?`}
                handleSupprimer={deleteBudgetFunction(row)}
              />
            )}
          </div>
        </>
      ),
    },
  ];

  const BudgetDetail = (row) => async () => {
    setBudgetId(row.id);
    setBudgetName(row.parameters.name);
    setRedirState(true);
  };

  const deleteBudgetFunction = (row) => async () => {
    let obj = dataBudgets.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteBudget(idSelected);
    axios
      .delete(url, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `Le Budget ${obj.parameters.name} a été supprimé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedBudgets(selection.selectedRows);
  };

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucun Budget à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        highlightOnHover
        pointerOnHover
        onRowClicked={(row) => {
          setBudgetId(row.id);
          setBudgetName(row.parameters.name);
          setRedirState(true);
        }}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      {redirecting}
    </>
  );
};

export default RTBudget;
